module.exports = {
  'Eric Windmill': {
    portfolio: 'https://ericwindmill.com',
    avatarUrl:
      'http://res.cloudinary.com/ericwindmill/image/upload/v1509817350/portfolio_site/no-bg-cartoon.png',
    email: 'eric@ericwindmill.com',
    twitter: 'https://twitter.com/ericwindmill?lang=en',
    github: 'https://github.com/ericwindmill',
    messenger: 'https://www.messenger.com/t/eric.windmill',
    instagram: 'https://www.instagram.com/ericwindmill',
    bio:
      'Dart and Flutter dev by day. JS and CSS on the side. Founder of this project.',
  },
  'Alex McCulloch': {
    avatarUrl:
      'http://res.cloudinary.com/ericwindmill/image/upload/v1527349506/flutter_by_example/authors/alex_m.jpg',
    email: 'alexmccx@gmail.com',
    twitter: 'https://twitter.com/axmccx',
    github: 'https://github.com/axmccx',
    messenger: 'https://www.messenger.com/t/axmccx ',
    bio: 'Student at the University of Toronto Mississauga, computer science.',
  },
}



// WEBPACK FOOTER //
// ./data/contributors.js